import { useQuery } from "react-query";
import { getWorkflowsListAPI } from "../../../../EditorLayout/Pages/Workflow/utils/workflowAPIs";

export const useGetWorkflowVariables = (appId, onSuccess, populate = false) => {
  const queryKey = ["GET_WORKFLOW_VARIABLES", appId];
  const population = populate
    ? [
        {
          path: "app",
          populate: {
            path: "account",
            select: "slug",
          },
          select: "name slug account summaryConfiguration",
        },
      ]
    : [];

  const defaultQuery = {
    query: {
      app: appId,
      syncVariables: true,
      selection: ["id", "name", "app", "variables"],
      population,
    },
    noLogError: true,
  };

  return useQuery(
    queryKey,
    async () => {
      const workflowdata = await getWorkflowsListAPI(defaultQuery);

      return workflowdata;
    },
    {
      enabled: !!appId,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        onSuccess(data);
      },
    }
  );
};
